import {
  Box,
  Button,
  IconButton,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from '@mui/material';
import React, { memo, useCallback, useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { API, graphqlOperation } from 'aws-amplify';
import { gettdstcsreport, gettdstcsreporttotals } from '../../graphql';
import moment from 'moment';
import { defaultRowsPerPageOptions, TRANSACTION_CONFIG } from '../../utils/common';
import { useGetCompanyCodeTranslationQuery } from '../../redux/apis/getCompanyCodeTranslation.api';
import { entityOptions } from '../../utils/customerData';
import { useThemes } from '../Theme/theme';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import TDSTCSCustomSearch from './CustomComponents/TDSTCSCustomSearch';
import CustomDate from '../Date/CustomDate';
// import { Close, Search } from '@mui/icons-material';
import SearchIcon from '@mui/icons-material/Search';
import dayjs from 'dayjs';
import { CustomTableCell } from '../../pages/LedgerTransaction/styles';
import { MoneyFormatv3 } from '../../library/MoneyFormat';
import { number } from 'yup';
import { DateRangeRsuite } from '../_components';

const ToolTip = styled(({ className, ...props }) => <Tooltip {...props} classes={{ popper: className }}></Tooltip>)(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    color: '#fff',
    backgroundColor: '#75428C',
    boxShadow: theme.shadows[1],
    fontSize: 13,
  },
}));
const styledTableCell = {
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  maxWidth: 200,
  padding: '6px !important',
  '& .MuiCheckbox-root': {
    padding: '4px',
  },
};

const CustomTableCellRedirectToVoucher = memo(({ data, type, children }) => {
  const newType = type === 'Purchase' ? 'PurchaseInvoice' : type === 'Sales' ? 'SalesInvoice' : type;
  const config = TRANSACTION_CONFIG[newType] || {
    path: '',
    getTransactionId: () => '',
  };
  const { path, getTransactionId } = config;
  const link = path ? `/${path}/${data.vouchNo}?transaction=${data.voucherId}` : '';
  const handleClick = useCallback(
    (e) => {
      // dispatch(
      //     updateTitle(data.vouchernumber)
      // );
      e.preventDefault();
      if (path) {
        window.open(link);
      }
    },
    [path, link]
  );

  return (
    <CustomTableCell>
      <a className="myLink" href={link} onClick={handleClick} style={{ border: 'none' }}>
        {children}
      </a>
    </CustomTableCell>
  );
});

function NewTDSTCSReport({ reportType, tableName, setLoading }) {
  const tableRef = useRef(null);
  const { theme } = useThemes();
  const headerType = reportType === 'TCSPAY' || reportType === 'TCSREC' ? 'TCS' : 'TDC';
  let headCells = [
    // {
    //   id: '1',
    //   label: 'SL.No',
    //   align: 'left',
    // },
    {
      id: '1',
      label: headerType === 'TCS' ? 'Date Of Collection' : 'Date Of Deduction',
      align: 'left',
    },
    {
      id: '3',
      label: 'Voucher No',
      align: 'left',
    },
    {
      id: '4',
      label: 'Voucher  Type',
      align: 'left',
    },
    {
      id: '5',
      // label:reportType==="TCS"?"Customer Name": "Supplier Name",
      label: 'Party Name',
      align: 'left',
    },
    {
      id: '6',
      label: 'PAN No',
      align: 'left',
    },
    {
      id: '8',
      label: 'Legal Entity',
      align: 'left',
    },
    {
      id: '10',
      label: 'Taxable Amount',
      align: 'right',
    },

    // {
    //   id: "10",
    //   label:reportType==="TCS"?"TCS Amount":"TDS Amount",
    //   align: "right",
    // },

    {
      id: '11',
      label: headerType === 'TCS' ? 'TCS %' : 'TDS %',
      align: 'right',
    },
    {
      id: '9',
      label: headerType === 'TCS' ? 'TCS Amount' : 'TDS Amount',
      align: 'right',
    },
    {
      id: '14',
      label: headerType === 'TCS' ? 'Amount After TCS ' : 'Amount After TDS ',
      align: 'right',
    },
    // {
    //   id: "12",
    //   label: headerType === "TCS" ? "TCS Section" : "TDS Section",
    //   align: "right",
    // },
    {
      id: '13',
      label: headerType === 'TCS' ? 'TCS Details' : 'TDS Details',
      align: 'left',
    },
  ];
  const totalHeaderName = {
    headerTotal: headerType === 'TCS' ? 'Total TCS Amount' : 'Total TDS Amount',
    headerTotalAfterTCSTDS: headerType === 'TCS' ? 'Total Amount After TCS' : 'Total Amount After TDS',
  };

  const format = (num) =>
    Number(num).toLocaleString('en', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  const latestReqIdRef = useRef(0);
  const dashboardData = useSelector((state) => state?.DashboardDataReducer);
  const { startTimeStamp, endTimeStamp } = dashboardData?.report;
  const [tdcsData, setTDCSData] = useState([]);
  const [enableSearch, setEnableSearch] = useState(false);
  const [totTdcsAmt, setTotTDCSAmt] = useState(0);
  const [amtAftrTDCS, setAmtAftrTDCS] = useState(0);
  const [totTaxableAmt, setTotaltaxableAmt] = useState(0);
  const [searchValues, setSearchValues] = useState({});
  const [filterColumns, setFilterColumns] = useState({
    InvoiceDateTo: '',
    InvoiceDateFrom: '',
  });
  const DateRangeRef = useRef(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const {
    data: codeTrasArr,
    isLoading: isTdsListLoading,
    isError: isTdsListError,
    // refetch
  } = useGetCompanyCodeTranslationQuery({
    codetype: headerType === 'TDS' ? '1' : '2',
  });

  async function getTDsTCSReport(startdt, enddt, value, rowfrom, limitno, open, mode, searchArr, reset) {
    const reqId = ++latestReqIdRef.current;
    setLoading(true);
    try {
      const resData = await API.graphql(
        graphqlOperation(gettdstcsreport, {
          type: reportType,
          startdate: startdt,
          enddate: enddt,
          rowfrom: rowfrom,
          limitno: limitno,
          word: value,
          searcharray: JSON.stringify(searchArr),
        })
      );
      let resTdsTcsReport = resData?.data?.gettdstcsreport;
      if (resTdsTcsReport !== null) {
        getTDSTCSTotal(startdt, enddt, value, searchArr);
        let arr = []; // Ensure arr is initialized

        resTdsTcsReport?.forEach((ele, index) => {
          let tdsText = ele?.tdsdetails || ''; // Handle undefined case
          let tdsDetail = tdsText;
          let tdsSectionPart = ''; // Default empty string for cases without "- Section"

          // Use a regex to correctly split even if there's an extra space or variation
          let match = tdsText.match(/(.*)\s*-\s*Section\s*(.*)/);

          if (match) {
            tdsDetail = match[1].trim(); // Part before "- Section"
            tdsSectionPart = match[2].trim(); // Part after "- Section"
          }

          // Find the entity label based on `legalentity` id
          let entityLabel = entityOptions.find((option) => option.id === ele?.legalentity)?.label || '';

          const obj = {
            slNo: index + 1,
            dateofDeduction: moment(ele?.invoicedate * 1000).format('DD-MMM-YYYY'),
            vouchNo: ele?.vouchernumber,
            voucherName: ele?.vouchertype,
            partyName: ele?.suppliername,
            legalEntity: entityLabel, // Set label of matched entity
            panNumber: ele?.pan_number,
            // deductedAmount: ele?.deductedamount,
            taxableAmount: ele?.deductedamount,
            deductedAmount: ele?.tdsamount,
            tdsAmount: ele?.tdsamount,
            tdsPercentage: ele?.tdspercentage,
            amountAfterTcds: Number(ele?.amountaftertds),
            // reportType === "TCS"
            //   ? Number(ele?.deductedamount) + Number(ele?.tdsamount)
            //   : Number(ele?.deductedamount) - Number(ele?.tdsamount),
            tdsSection: tdsSectionPart, // Extracted section value (e.g., "194 H"), empty if not found
            tdsDetails: tdsDetail, // Extracted details value (e.g., "Commission or Brokerage(Reduced)")
            totalCount: ele?.totalcount,
            voucherId: ele?.id,
          };

          arr.push(obj);
        });

        // setTDCSData(arr);
        // if (reset == true) {
        //   setTDCSData(arr);
        // } else {
        //   setTDCSData((prev) => [...prev, ...arr]);
        // }

        if (reset === true) {
          const uniqueArr = arr.filter((item, index, self) => index === self.findIndex((t) => t.vouchNo === item.vouchNo));
          setTDCSData(uniqueArr);
        } else {
          setTDCSData((prev) => {
            const merged = [...prev, ...arr];
            const unique = merged.filter((item, index, self) => index === self.findIndex((t) => t.vouchNo === item.vouchNo));
            return unique;
          });
        }
      }
    } catch (error) {
      console.log('error', error);
    } finally {
      if (reqId === latestReqIdRef.current) {
      }
      setLoading(false);
    }
  }
  async function getTDSTCSTotal(startdt, enddt, value, searchArr) {
    setLoading(true);
    try {
      const resData = await API.graphql(
        graphqlOperation(gettdstcsreporttotals, {
          type: reportType,
          startdate: startdt,
          enddate: enddt,
          word: value,
          searcharray: JSON.stringify(searchArr),
        })
      );
      const totalObj = resData?.data?.gettdstcsreporttotals?.[0];
      if (totalObj) {
        setTotaltaxableAmt(totalObj?.totaltaxableamount);
        setTotTDCSAmt(totalObj?.totaltdsamount);
        setAmtAftrTDCS(totalObj?.totalamountaftertds);
      }
    } catch (error) {
      console.log('error', error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    let searchArr = [];
    getTDsTCSReport(startTimeStamp, endTimeStamp, '', 0, rowsPerPage, true, 0, searchArr, false);
    setSearchValues({});
    setFilterColumns((prev) => ({
      ...prev,
      InvoiceDateFrom: '',
      InvoiceDateTo: '',
    }));
  }, [startTimeStamp, endTimeStamp, rowsPerPage]);
  // async function handleSearchChange(value, name) {
  //   if (value !== "") {
  //     setPage(0);

  //     let searchArr = [{ [name]: value }];

  //     await getTDsTCSReport(
  //       startTimeStamp,
  //       endTimeStamp,
  //       "",
  //       0,
  //       25,
  //       false,
  //       1,
  //       searchArr
  //     );
  //   }
  //   else {
  //     getTDsTCSReport(startTimeStamp, endTimeStamp, "", 0, 25, true, 0, []);
  //   }
  // }
  async function handleSearchChange(value, name) {
    setPage(0);
    setSearchValues((prev) => {
      const updatedSearch = { ...prev };

      if (value !== '') {
        updatedSearch[name] = value;
      } else {
        delete updatedSearch[name]; // Remove field if cleared
      }

      const searchArr = Object.entries(updatedSearch).map(([key, val]) => ({
        [key]: val,
      }));

      getTDsTCSReport(
        startTimeStamp,
        endTimeStamp,
        '',
        0,
        rowsPerPage,
        Object.keys(updatedSearch).length === 0, // isClear
        Object.keys(updatedSearch).length === 0 ? 0 : 1, // isSearch
        searchArr,
        true
      );

      return updatedSearch;
    });
  }

  // async function handleDateSearchChange(fromDate, toDate, from, to) {
  //   let searchArr = [{ [from]: fromDate }, { [to]: toDate }];

  //   if (searchArr.length > 0) {
  //     setPage(0);

  //     await getTDsTCSReport(
  //       startTimeStamp,
  //       endTimeStamp,
  //       "",
  //       0,
  //       25,
  //       false,
  //       1,
  //       searchArr
  //     );
  //   } else {
  //     getTDsTCSReport(startTimeStamp, endTimeStamp, "", 0, 25, true, 0, []);
  //   }
  // }
  async function handleDateSearchChange(fromDate, toDate, fromKey, toKey) {
    setPage(0);

    setSearchValues((prev) => {
      const updatedSearch = { ...prev };

      if (fromDate) {
        updatedSearch[fromKey] = fromDate;
      } else {
        delete updatedSearch[fromKey];
      }

      if (toDate) {
        updatedSearch[toKey] = toDate;
      } else {
        delete updatedSearch[toKey];
      }

      const searchArr = Object.entries(updatedSearch).map(([key, val]) => ({
        [key]: val,
      }));

      getTDsTCSReport(
        startTimeStamp,
        endTimeStamp,
        '',
        0,
        rowsPerPage,
        Object.keys(updatedSearch).length === 0, // isClear
        Object.keys(updatedSearch).length === 0 ? 0 : 1, // isSearch
        searchArr,
        true
      );

      return updatedSearch;
    });
  }

  useEffect(() => {
    if (filterColumns) {
      handleDateSearchChange(filterColumns.InvoiceDateFrom, filterColumns.InvoiceDateTo, 'searchdatefrom', 'searchdateto');
    }
  }, [filterColumns]);

  function handleBulkSearchChange(updatesObj) {
    // updatesObj example:
    // { searchvoucherno: '', searchvouchername: '', amountaftertds: '' }
    setPage(0);
    setSearchValues((prev) => {
      const updated = { ...prev };
      Object.entries(updatesObj).forEach(([key, val]) => {
        if (val !== '') updated[key] = val;
        else delete updated[key];
      });
      return updated;
    });
  }
  useEffect(() => {
    const handleScroll = () => {
      if (tableRef.current) {
        const { scrollLeft, scrollWidth, clientWidth } = tableRef.current;
        // Check if the table is scrolled to the very right
      }
    };

    const tableElement = tableRef.current;
    if (tableElement) {
      tableElement.addEventListener('scroll', handleScroll);
    }

    return () => {
      if (tableElement) {
        tableElement.removeEventListener('scroll', handleScroll);
      }
    };
  }, []);
  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          // mb: 1,
        }}
      >
        {/* <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Typography
            sx={{
              fontWeight: 600,
              fontSize: "16px",
              color: theme?.palette?.TmId.id.toString().includes("9")
                ? "white"
                : "black",
            }}
          >
            {reportType + " " + "Report Party wise"}
          </Typography>
          <TextField
            type="text"
            size="small"
            placeholder="Search"
            onChange={(e) => {
              handleSearchChange(e?.target?.value);
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                height: "35px",
                borderRadius: "4px",
              },
              "& input": {
                padding: "8px",
              },
            }}
          />
        </Box> */}
      </Box>

      <Box
        sx={{
          width: '100%',
          overflow: 'hidden',
          // marginTop: 1,
        }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <Typography
              sx={{
                fontWeight: 'bold',
                width: '180px', // ⬅️ narrower fixed width for closer alignment
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
            >
              {tableName}
            </Typography>

            <Tooltip title="Search" placement="top">
              <Button
                sx={{
                  borderWidth: '3px',
                  borderColor: 'primary.main',
                  borderStyle: 'solid',
                  backgroundColor: enableSearch === true && '#f3724a',
                  whiteSpace: 'nowrap',
                  fontWeight: 'bold',
                  '&:active': {
                    transform: 'scale(0.92)',
                    boxShadow: 'inset 0px 0px 5px rgba(0, 0, 0, 0.4)',
                  },
                  '&:hover': {
                    backgroundColor: enableSearch ? '#f3724a' : 'white',
                  },
                  height: '28px',
                  minWidth: '10px',
                  width: '30px',
                }}
                variant="outlined"
                onClick={() => {
                  setEnableSearch((prev) => {
                    const newState = !prev;

                    if (prev === true) {
                      setFilterColumns({
                        InvoiceDateTo: '',
                        InvoiceDateFrom: '',
                      });
                      handleBulkSearchChange({
                        searchvoucherno: '',
                        searchvouchername: '',
                        searchpartyname: '',
                        searchpanno: '',
                        searchlegalentity: '',
                        searchtaxableamount: '',
                        searchtdspercentage: '',
                        searchdeductedamount: '',
                        amountaftertds: '',
                        searchtdsdetails: '',
                      });
                    }

                    return newState;
                  });
                }}
              >
                <SearchIcon sx={{ fontSize: 20 }} /> {/* ⬅️ even smaller icon */}
              </Button>
            </Tooltip>
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Stack direction="row" spacing={1} alignItems="center">
              <Typography sx={{ fontWeight: 600, fontSize: { xs: '11px', sm: '16px' } }}>
                Total Taxable Amount : ₹ {MoneyFormatv3(Number(totTaxableAmt).toFixed(2), 'en-IN')}
              </Typography>
              <Typography sx={{ fontWeight: 600, fontSize: { xs: '11px', sm: '16px' } }}>
                {totalHeaderName.headerTotal} : ₹ {MoneyFormatv3(Number(totTdcsAmt).toFixed(2), 'en-IN')}
              </Typography>
              <Typography sx={{ fontWeight: 600, fontSize: { xs: '11px', sm: '16px' } }}>
                {totalHeaderName.headerTotalAfterTCSTDS} : ₹ {MoneyFormatv3(Number(amtAftrTDCS).toFixed(2), 'en-IN')}
              </Typography>
            </Stack>
          </Box>
        </Box>

        <TableContainer
          sx={{
            m: 1,
            '::-webkit-scrollbar': {
              width: 5,
            },
            '::-webkit-scrollbar-track': {
              // background: "#f1f1f1",
            },
            '::-webkit-scrollbar-thumb': {
              background: `${theme.palette.primary.main}`,
            },
            maxHeight: 500,
          }}
        >
          <Table
            stickyHeader
            aria-label="sticky table"
            // sx={{ borderRadius: 2, backgroundColor: "#f9f9fe" }}
            sx={{ borderRadius: 2 }}
          >
            <TableHead>
              <TableRow className="noTableCellBorder">
                {headCells?.map((column) => (
                  <TableCell
                    align={column.align}
                    sx={{
                      // color: "#FFF !important",
                      // backgroundColor: `${theme.palette.primary.main} !important`,

                      fontFamily: 'overpass',
                      fontSize: 14,
                      fontWeight: 'bold',
                      minWidth: column.label !== 'SL.No' ? '120px' : '40px',
                      whiteSpace: 'nowrap', // Prevents wrapping
                      width: 'auto', // Adjusts width based on content
                      padding: '6px',
                      border: 'none !important',
                    }}
                  >
                    {/* <Typography direction="row" alignItems="right" spacing={1}> */}
                    <span>{column.label}</span>
                    {/* {column.label !== "SL.No" && (
                      <IconButton
                        onClick={() => setEnableSearch((prev) => !prev)}
                        sx={{ color: "#FFF", padding: 0, ml: 1 }}
                      >
                        <Search sx={{ fontSize: 20 }} />
                      </IconButton>
                    )} */}
                    {/* </Typography> */}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow
                sx={{
                  '.MuiTableCell-root': {
                    backgroundColor: 'transparent ',
                    padding: '8px 6px',
                    borderBottom: 'none',
                  },
                  '.css-wrnu0i-MuiInputBase-root': {
                    fontSize: '13px',
                  },
                  '.css-xk0adg-MuiButtonBase-root-MuiIconButton-root': {
                    padding: '2px 4px',
                  },
                  '.css-1gqfvv-MuiPaper-root': {
                    // boxShadow: "none",
                    // borderBottom: "solid 1px rgba(0,0,0,0.24)",
                    borderRadius: '0px',
                  },
                  display: !enableSearch ? 'none' : '',
                }}
              >
                {/* <TableCell></TableCell> */}
                <TableCell sx={{ border: 'none !important' }}>
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    {/* <CustomDate
                      ref={DateRangeRef}
                      value={[
                        filterColumns.InvoiceDateFrom ? dayjs.unix(filterColumns.InvoiceDateFrom) : null,
                        filterColumns.InvoiceDateTo ? dayjs.unix(filterColumns.InvoiceDateTo) : null,
                      ]}
                      onChange={(e) => {
                        setFilterColumns((prev) => ({
                          ...prev,
                          InvoiceDateFrom: e.from || '',
                          InvoiceDateTo: e.to || '',
                        }));
                      }}
                    />
                    {filterColumns.InvoiceDateFrom || filterColumns.InvoiceDateTo ? (
                      <IconButton
                        type="button"
                        sx={{ p: '0px', fontSize: '20px' }}
                        onClick={() => {
                          setFilterColumns((prev) => ({
                            ...prev,
                            InvoiceDateFrom: '',
                            InvoiceDateTo: '',
                          }));
                          if (DateRangeRef.current?.clear) {
                            DateRangeRef.current.clear(); // Optional: if CustomDate has a `clear` method
                          }
                        }}
                      >
                        <Close />
                      </IconButton>
                    ) : (
                      <IconButton type="button" sx={{ p: '0px', fontSize: '20px' }}>
                        <Search />
                      </IconButton>
                    )} */}
                    <DateRangeRsuite
                      ref={DateRangeRef}
                      containerRef={tableRef}
                      value={[
                        filterColumns.InvoiceDateFrom ? filterColumns.InvoiceDateFrom : null,
                        filterColumns.InvoiceDateTo ? filterColumns.InvoiceDateTo : null,
                      ]}
                      onChange={(e) => {
                        setFilterColumns((prev) => ({
                          ...prev,
                          InvoiceDateFrom: e.from || '',
                          InvoiceDateTo: e.to || '',
                        }));
                      }}
                    />
                  </Box>
                </TableCell>

                <TableCell sx={{ border: 'none !important', alignItems: 'left' }}>
                  <TDSTCSCustomSearch
                    fieldType=""
                    searchValues={searchValues['searchvoucherno']}
                    onChange={(e) => handleSearchChange(e?.target?.value, 'searchvoucherno')}
                    onClick={() => handleSearchChange('', 'searchvoucherno')}
                  />
                </TableCell>
                <TableCell sx={{ border: 'none !important', alignItems: 'left' }}>
                  <TDSTCSCustomSearch
                    fieldType=""
                    searchValues={searchValues['searchvouchername']}
                    onChange={(e) => handleSearchChange(e?.target?.value, 'searchvouchername')}
                    onClick={(e) => handleSearchChange('', 'searchvouchername')}
                  />
                </TableCell>
                <TableCell sx={{ border: 'none !important', alignItems: 'left' }}>
                  <TDSTCSCustomSearch
                    fieldType=""
                    searchValues={searchValues['searchpartyname']}
                    onChange={(e) => handleSearchChange(e?.target?.value, 'searchpartyname')}
                    onClick={(e) => handleSearchChange('', 'searchpartyname')}
                  />
                </TableCell>
                <TableCell sx={{ border: 'none !important', alignItems: 'left' }}>
                  <TDSTCSCustomSearch
                    fieldType=""
                    searchValues={searchValues['searchpanno']}
                    onChange={(e) => handleSearchChange(e?.target?.value, 'searchpanno')}
                    onClick={(e) => handleSearchChange('', 'searchpanno')}
                  />
                </TableCell>
                <TableCell sx={{ border: 'none !important', alignItems: 'left' }}>
                  <TDSTCSCustomSearch
                    fieldType=""
                    searchValues={searchValues['searchlegalentity']}
                    onChange={(e) => handleSearchChange(e?.target?.value, 'searchlegalentity')}
                    onClick={(e) => handleSearchChange('', 'searchlegalentity')}
                  />
                </TableCell>
                <TableCell sx={{ border: 'none !important', alignItems: 'right' }}>
                  <TDSTCSCustomSearch
                    fieldType=""
                    searchValues={searchValues['searchtaxableamount']}
                    onChange={(e) => handleSearchChange(e?.target?.value, 'searchtaxableamount')}
                    onClick={(e) => handleSearchChange('', 'searchtaxableamount')}
                  />
                </TableCell>
                <TableCell sx={{ border: 'none !important', alignItems: 'right' }}>
                  <TDSTCSCustomSearch
                    fieldType=""
                    searchValues={searchValues['searchtdspercentage']}
                    onChange={(e) => handleSearchChange(e?.target?.value, 'searchtdspercentage')}
                    onClick={(e) => handleSearchChange('', 'searchtdspercentage')}
                  />
                </TableCell>
                <TableCell sx={{ border: 'none !important', alignItems: 'right' }}>
                  <TDSTCSCustomSearch
                    fieldType=""
                    searchValues={searchValues['searchdeductedamount']}
                    onChange={(e) => handleSearchChange(e?.target?.value, 'searchdeductedamount')}
                    onClick={(e) => handleSearchChange('', 'searchdeductedamount')}
                  />
                </TableCell>
                <TableCell sx={{ border: 'none !important', alignItems: 'right' }}>
                  <TDSTCSCustomSearch
                    fieldType=""
                    searchValues={searchValues['amountaftertds']}
                    onChange={(e) => handleSearchChange(e?.target?.value, 'amountaftertds')}
                    onClick={(e) => handleSearchChange('', 'amountaftertds')}
                  />
                </TableCell>
                {/* <TableCell
                  sx={{ border: "none !important", alignItems: "left" }}
                >
                  <TDSTCSCustomSearch
                    fieldType=""
                    onChange={(e) =>
                      handleSearchChange(e?.target?.value, "searchtdssection")
                    }
                  />
                </TableCell> */}
                <TableCell sx={{ border: 'none !important', alignItems: 'left' }}>
                  <TDSTCSCustomSearch
                    fieldType=""
                    searchValues={searchValues['searchtdsdetails']}
                    onChange={(e) => handleSearchChange(e?.target?.value, 'searchtdsdetails')}
                    onClick={(e) => handleSearchChange('', 'searchtdsdetails')}
                  />
                </TableCell>
              </TableRow>
              {tdcsData.length === 0 ? (
                <>
                  <TableRow>
                    <TableCell
                      colSpan={enableSearch && tdcsData.length === 0 ? 8 : headCells?.length}
                      align="center"
                      sx={{
                        color: '#818694',
                        fontFamily: 'overpass',
                        fontSize: 15,
                        fontWeight: 'bold',
                        border: 'none !important',
                      }}
                    >
                      NO DATA FOUND
                    </TableCell>
                  </TableRow>
                </>
              ) : (
                <>
                  {tdcsData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => {
                    return (
                      <TableRow
                        className="noTableCellBorder"
                        sx={{
                          '.MuiTableCell-root': {
                            backgroundColor: 'transparent ',
                            padding: '8px 6px',
                            borderBottom: 'none',
                          },
                        }}
                      >
                        {/* <TableCell sx={styledTableCell} align="left" padding="none">
                          <ToolTip title={row?.slNo} tooltipContent={row?.slNo}>
                            {row?.slNo}
                          </ToolTip>
                        </TableCell> */}

                        <TableCell sx={styledTableCell} align="left" padding="none">
                          <ToolTip title={row?.dateofDeduction} tooltipContent={row?.dateofDeduction}>
                            {row?.dateofDeduction}
                          </ToolTip>
                        </TableCell>

                        {/* <TableCell align="left" padding="none">
                            <ToolTip
                              title={row?.vouchNo}
                              tooltipContent={row?.vouchNo}
                            >
                              {row?.vouchNo}
                            </ToolTip>
                          </TableCell> */}
                        <CustomTableCellRedirectToVoucher data={row} type={row.voucherName}>
                          {row?.vouchNo}
                        </CustomTableCellRedirectToVoucher>

                        <TableCell sx={styledTableCell} align="left" padding="none">
                          <ToolTip title={row?.voucherName} tooltipContent={row?.voucherName}>
                            {row?.voucherName}
                          </ToolTip>
                        </TableCell>
                        <TableCell sx={styledTableCell} align="left" padding="none">
                          <ToolTip title={row?.partyName} tooltipContent={row?.partyName}>
                            {row?.partyName}
                          </ToolTip>
                        </TableCell>

                        <TableCell sx={styledTableCell} align="left" padding="none">
                          <ToolTip title={row?.panNumber} tooltipContent={row?.panNumber}>
                            {row?.panNumber}
                          </ToolTip>
                        </TableCell>
                        <TableCell sx={styledTableCell} align="left" padding="none">
                          <ToolTip title={row?.legalEntity} tooltipContent={row?.legalEntity}>
                            {row?.legalEntity}
                          </ToolTip>
                        </TableCell>
                        <TableCell align="right" padding="none" sx={{ width: '100%', whiteSpace: 'nowrap' }}>
                          <ToolTip title={row?.taxableAmount} tooltipContent={row?.taxableAmount}>
                            ₹ {MoneyFormatv3(Number(row?.taxableAmount).toFixed(2), 'en-IN')}
                          </ToolTip>
                        </TableCell>

                        <TableCell sx={styledTableCell} align="right" padding="none">
                          <ToolTip title={row?.tdsPercentage} tooltipContent={row?.tdsPercentage}>
                            {row?.tdsPercentage}
                          </ToolTip>
                        </TableCell>

                        <TableCell sx={styledTableCell} align="right" padding="none">
                          <ToolTip title={row?.tdsAmount} tooltipContent={row?.tdsAmount}>
                            ₹ {MoneyFormatv3(Number(row?.tdsAmount).toFixed(2), 'en-IN')}
                          </ToolTip>
                        </TableCell>
                        <TableCell sx={styledTableCell} align="right" padding="none">
                          <ToolTip title={row?.amountAfterTcds} tooltipContent={row?.amountAfterTcds}>
                            ₹ {MoneyFormatv3(Number(row?.amountAfterTcds).toFixed(2), 'en-IN')}
                          </ToolTip>
                        </TableCell>
                        {/* <TableCell
                            sx={styledTableCell}
                            align="right"
                            padding="none"
                          >
                            <ToolTip
                              title={row?.tdsSection}
                              tooltipContent={row?.tdsSection}
                            >
                              {row?.tdsSection}
                            </ToolTip>
                          </TableCell> */}
                        <TableCell sx={styledTableCell} align="left" padding="none">
                          <ToolTip title={row?.tdsDetails} tooltipContent={row?.tdsDetails}>
                            {row?.tdsDetails}
                          </ToolTip>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        {tdcsData.length > 0 && (
          <TablePagination
            rowsPerPageOptions={defaultRowsPerPageOptions}
            component="div"
            count={tdcsData?.[0]?.totalCount}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={(event, newPage) => {
              if (newPage > page) {
                if (tdcsData?.length !== tdcsData?.[0]?.totalCount)
                  if (tdcsData.length < rowsPerPage * (newPage + 1)) {
                    getTDsTCSReport(
                      startTimeStamp,
                      endTimeStamp,
                      '',
                      tdcsData?.length,
                      Math.abs(rowsPerPage * (newPage + 1) - tdcsData.length),
                      true,
                      1,
                      [],
                      false
                    );
                  }
              }
              setPage(newPage);
            }}
            onRowsPerPageChange={(event) => {
              setRowsPerPage(parseInt(event.target.value, 10));
              setPage(0);
            }}
          />
        )}
      </Box>
    </Box>
  );
}

export default NewTDSTCSReport;
